<template>
  <LoginLayout>
    <template #container>
      <LoginContainer
        :title="$t('login.loginPage.addPersonalInfo')"
        :has-back="true"
        @back="back"
      >
        <template #form>
          <component ref="form" :is="'PersonalInfo'" />
        </template>
      </LoginContainer>
    </template>
  </LoginLayout>
</template>
<script>
import LoginLayout from '@/components/login/LoginLayout.vue'
import LoginContainer from '@/components/login/LoginContainer.vue'
import PersonalInfo from './components/PersonalInfo.vue'
import BaseMixin from '@/mixins/BaseMixin'
export default {
  mixins: [BaseMixin],
  components: {
    LoginLayout,
    LoginContainer,
    PersonalInfo,
  },
  props: {},
  data() {
    return {
      input: '',
    }
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    back() {
      if (this.type === 'phone') {
        this.$router.push({
          path: '/login/phone/account',
          query: { ...this.$route.query },
        })
      } else {
        this.$router.push({
          path: '/login/email/account',
          query: { ...this.$route.query },
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
